import { render, staticRenderFns } from "./dialog-managestorage-multi.vue?vue&type=template&id=5f98770e&"
import script from "./dialog-managestorage-multi.vue?vue&type=script&lang=js&"
export * from "./dialog-managestorage-multi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports